import { readFile, writeFile } from "node:fs/promises";
import type { WorklogEntry } from "./types.js";

/**
 * Append a new section to the end of an existing worklog entry's file.
 *
 * The resulting markdown adds two leading blank lines, then `## <title>`,
 * then a blank line, then the body. The entry's frontmatter is not touched.
 *
 * Returns the updated raw markdown that was written.
 */
export async function appendSection(
  entry: WorklogEntry,
  title: string,
  body: string,
): Promise<string> {
  const original = await readFile(entry.path, "utf8");
  const trimmed = original.replace(/\s+$/u, "");
  const section = `## ${title}\n\n${body.trimEnd()}\n`;
  const next = `${trimmed}\n\n${section}`;
  await writeFile(entry.path, next, "utf8");
  return next;
}
